import { FETCH_PRICE_TABLE_FILTERED_FUNDS } from '../../../actions/priceTable/table';
import { dateFilterFormTracking } from './table';

export const priceTableTracking = (store, next, action) => {
    if (action.type === FETCH_PRICE_TABLE_FILTERED_FUNDS) {
        return dateFilterFormTracking(store, next, action);
    }
}
